function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.46836 2.55703C9.87712 2.14826 10.4382 2 11.0296 2H13.4926C14.0839 2 14.6451 2.14826 15.0538 2.55703C15.4626 2.96579 15.6108 3.5269 15.6108 4.11823V4.95517L20.8818 4.95567C21.2355 4.95567 21.5222 5.24238 21.5222 5.59606C21.5222 5.94974 21.2355 6.23645 20.8818 6.23645H19.0591V18.4039C19.0591 19.4889 18.7879 20.3972 18.2233 21.0424C17.649 21.6988 16.8435 22 15.9557 22H9.05911C8.18375 22 7.28745 21.7089 6.60164 21.0993C5.90405 20.4792 5.46305 19.5629 5.46305 18.4039V6.23645H3.64039C3.28671 6.23645 3 5.94974 3 5.59606C3 5.24238 3.28671 4.95567 3.64039 4.95567H8.91133V4.11823C8.91133 3.5269 9.0596 2.96579 9.46836 2.55703ZM10.1921 4.95567H14.33V4.11823C14.33 3.72433 14.232 3.54653 14.1482 3.46268C14.0643 3.37883 13.8865 3.28079 13.4926 3.28079H11.0296C10.6357 3.28079 10.4579 3.37883 10.374 3.46268C10.2902 3.54653 10.1921 3.72433 10.1921 4.11823V4.95567ZM6.74384 6.23645V18.4039C6.74384 19.2154 7.04177 19.7769 7.45255 20.1421C7.87512 20.5177 8.45665 20.7192 9.05911 20.7192H15.9557C16.5457 20.7192 16.9717 20.5278 17.2594 20.199C17.5569 19.859 17.7783 19.2895 17.7783 18.4039V6.23645H6.74384Z",
  fill: "#3D4967"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.05911 8.89655C9.41279 8.89655 9.69951 9.18327 9.69951 9.53695V16.9261C9.69951 17.2798 9.41279 17.5665 9.05911 17.5665C8.70543 17.5665 8.41872 17.2798 8.41872 16.9261V9.53695C8.41872 9.18327 8.70543 8.89655 9.05911 8.89655Z",
  fill: "#3D4967"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.3644 8.89655C15.7181 8.89655 16.0048 9.18327 16.0048 9.53695V16.9261C16.0048 17.2798 15.7181 17.5665 15.3644 17.5665C15.0108 17.5665 14.724 17.2798 14.724 16.9261V9.53695C14.724 9.18327 15.0108 8.89655 15.3644 8.89655Z",
  fill: "#3D4967"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.2118 8.89655C12.5655 8.89655 12.8522 9.18327 12.8522 9.53695V16.9261C12.8522 17.2798 12.5655 17.5665 12.2118 17.5665C11.8581 17.5665 11.5714 17.2798 11.5714 16.9261V9.53695C11.5714 9.18327 11.8581 8.89655 12.2118 8.89655Z",
  fill: "#3D4967"
});

function SvgDeleteTrashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteTrashIcon);
export default __webpack_public_path__ + "static/media/DeleteTrashIcon.5038efeb.svg";
export { ForwardRef as ReactComponent };